module.exports = __webpack_public_path__ + "img/精致美型--嘴型gif.0379e4fa.gif";